import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../features/userSlice';
import authReducer from '../features/authSlice';
import authFormReducer from '../features/authFormSlice';
import uiReducer from '../features/uiSlice';
import dataReducer from '../features/dataSlice';

// Redux Toolkit Storeの設定
// 状態管理を一元化し、複数のsliceを統合
export const store = configureStore({
  reducer: {
    user: userReducer,      // ユーザー関連の状態
    auth: authReducer,      // 認証関連の状態
    authForm: authFormReducer, // 認証フォーム関連の状態
    ui: uiReducer,          // UI関連の状態（モーダル、ローディング等）
    data: dataReducer,      // データ関連の状態（店舗情報、日付等）
  },
  // Redux DevTools有効化（開発環境のみ）
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
